import { Empty, Table, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../nestserver";
import MomentDatePicker from "../inputs/MomentDatePicker";

/**
 * Admin: staff members who were checked in and on time on every working day
 * of a month. Awards are generated on the 1st for the previous month.
 */
const StarStaff = () => {
  const [month, setMonth] = useState(moment().subtract(1, "month"));
  const monthStr = month.format("YYYY-MM");

  const list = useQuery(["star-staff", monthStr], async () => {
    const res = await axios.get(
      `${serverUrl}/attendance-appreciation/staff/list`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
        params: { month: monthStr },
      },
    );
    return res.data?.result?.data || [];
  });

  const columns = [
    { title: "Staff member", dataIndex: "name" },
    {
      title: "Working days",
      dataIndex: "working_days",
      render: (v) => (
        <Tag color="green">
          {v} / {v}
        </Tag>
      ),
    },
  ];

  return (
    <div className="pt-8">
      <div className="bg-white p-10 rounded-2xl">
        <div className="text-2xl text-orange-500 font-semibold pb-2">
          Star Staff
        </div>
        <div className="text-gray-500 pb-6">
          Checked in and on time every working day in{" "}
          {month.format("MMMM YYYY")}
        </div>

        <div className="pb-4">
          <MomentDatePicker
            picker="month"
            value={month}
            allowClear={false}
            format="MMMM YYYY"
            disabledDate={(d) => d && d.isAfter(moment().endOf("month"))}
            onChange={(d) => d && setMonth(d)}
          />
        </div>

        <Table
          rowKey="_id"
          columns={columns}
          dataSource={list.data || []}
          loading={list.isLoading}
          pagination={{ pageSize: 10 }}
          locale={{
            emptyText: (
              <Empty description="No staff member had 100% attendance this month" />
            ),
          }}
        />
      </div>
    </div>
  );
};

export default StarStaff;
